import Service from "../../../Services/index";

const BagData = {
    namespaced: true,
    state: {
        bagDataList:[],
        bagData:[],
        bag_type : [],
        bag_status : [],
        bag_all : [],
        search :{
            list :"",
            vendor :"",
            date :"",
            type : ""
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
    },
    mutations: {
        GET_BAG_DATA_LIST: (state, res) => {
            state.bagDataList = res.data
                .map(bag => ({
                ...bag,
                show: 0
            }));
            state.dataPaginate = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        },
        GET_BAG_DATA_ID:(state,res)=>{
            state.bagData = res;
        },
        GET_BAG_TYPE :(state,res)=>{
            state.bag_type = res;
        },
        GET_BAG_DATA_STATUS:(state,res)=>{
            state.bag_status = res;
        },
        GET_BAG_DATA_ALL : (state,res)=>{
            state.bag_all = res;
        },
        CLEAR_SEARCH:(state)=>{
            state.search = {
                list :"",
                vendor :"",
                date :"",
                type : ""
            }
        },
    },
    actions: {
        setBagData({ commit },page=1) {
            return Service.BagData.getBagData(page)
                .then(response => {
                    commit("GET_BAG_DATA_LIST", response)
            });
        },
        getBagDataFromStatus({commit}){
            return Service.BagData.getBagDataFromStatus().then(response=>{
                commit("GET_BAG_DATA_STATUS",response);
            })
        },
        getBagDataAll({ commit }){
            return Service.BagData.getBagDataAll().then(response=>{
                commit("GET_BAG_DATA_ALL",response);
            })
        },

        getBagDataFromType({commit},{page=1,type_id}){
          return Service.BagData.getBagDataFromType(page,type_id).then(response=>{
              commit("GET_BAG_DATA_LIST", response)
          });
        },
        getBagType({commit}){
          return Service.BagData.getBagType().then(res=>{
              commit("GET_BAG_TYPE",res);
          })
        },
        showBagData({commit},id){
            return Service.BagData.showBagData(id).then(res=>{
                commit("GET_BAG_DATA_ID",res);
            })
        },
        save({commit}){
            //create
            //update
        },
        delete({commit},id){
            return Service.BagData.deleteBagData(id);
        },
        search({commit},data){
            console.log(data);
            return Service.BagData.searchBagData(data).then(response=>{
                commit("GET_BAG_DATA_LIST", response)
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        }
    }
};

export default BagData;
